import type { ZodTypeAny } from "zod";
import { z } from "zod";

const string = z.string().min(1);

const optional = {
  boolean: z.boolean().optional(),
  string: z.string().optional(),
  number: z.number().optional(),
  array<T extends ZodTypeAny>(type: T) {
    return z.array(type).optional();
  },
};

const route = z.object({
  hasAction: z.boolean(),
  hasClientAction: z.boolean(),
  hasLoader: z.boolean(),
  hasClientLoader: z.boolean(),
  hasErrorBoundary: z.boolean(),
  index: optional.boolean,
  caseSensitive: optional.boolean,
  imports: optional.array(string),
  id: string,
  module: string,
  path: optional.string,
  parentId: optional.string,
});

const manifest = z.object({
  url: string,
  version: string,
  routes: z.record(route),
  entry: z.object({
    imports: z.array(string),
    module: string,
  }),
});
// TODO: Finne en måte å teste dette på bygget. Som kan si ifra om dette endres fra RR sin side.
export type AssetsManifest = z.infer<typeof manifest>;

/**
 * Schema for messages sent to the service worker that can be used in both ends of postMessage to ensure type safety. On new use cases for messaging, expand
 * the schema with the new message type.
 */
export const clientToWorkerMessageSchema = z
  .object({
    type: z.literal("REMIX_NAVIGATION"),
    authenticated: z.boolean(),
    manifest,
    isMount: z.boolean(),
  })
  .or(
    z.object({
      type: z.literal("SYNC_REMIX_MANIFEST"),
      manifest,
      authenticated: z.boolean().optional(),
    }),
  )
  .or(
    z.object({
      type: z.literal("LOGOUT"),
    }),
  )
  .or(
    z.object({
      type: z.literal("SKIP_WAITING"),
    }),
  )
  .or(
    z.object({
      type: z.literal("CLOSE_DAYPLAN_NOTIFICATION"),
      dayPlanDate: z.date(),
    }),
  )
  .or(
    z
      .object({
        type: z.literal("REQUEST_SERVICE_WORKER_VERSION"),
      })
      .or(
        z.object({
          type: z.literal("DELETE_CACHES"),
        }),
      ),
  );

export type ClientToWorkerMessage = z.infer<typeof clientToWorkerMessageSchema>;

/**
 * Wrapper for making messaging between app and service worker type-safe.
 *
 * @param message
 */
export const postSwMessage = (message: ClientToWorkerMessage) => {
  window.navigator.serviceWorker?.controller?.postMessage(message);
};
